var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-card" },
    [
      _c("div", { staticClass: "order-header", on: { click: _vm.toggle } }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.order.selected,
              expression: "order.selected"
            }
          ],
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.order.selected)
              ? _vm._i(_vm.order.selected, null) > -1
              : _vm.order.selected
          },
          on: {
            click: function($event) {
              $event.stopPropagation()
            },
            change: function($event) {
              var $$a = _vm.order.selected,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && _vm.$set(_vm.order, "selected", $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    _vm.$set(
                      _vm.order,
                      "selected",
                      $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                    )
                }
              } else {
                _vm.$set(_vm.order, "selected", $$c)
              }
            }
          }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "info" }, [
          !_vm.order.isEdit
            ? _c("strong", [
                _vm._v("依頼番号 : " + _vm._s(_vm.order.requestNo))
              ])
            : _c(
                "strong",
                {
                  staticClass: "input-edit",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.order.requestNo,
                        expression: "order.requestNo"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "bg-input-error": !_vm.validateRequestNo() },
                    attrs: { type: "text" },
                    domProps: { value: _vm.order.requestNo },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.order, "requestNo", $event.target.value)
                      }
                    }
                  })
                ]
              ),
          _vm._v(" "),
          !_vm.order.isEdit
            ? _c("strong", [
                _vm._v("出荷名 : " + _vm._s(_vm.order.shippingName))
              ])
            : _c(
                "strong",
                {
                  staticClass: "input-edit",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                    }
                  }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.order.shippingName,
                        expression: "order.shippingName"
                      }
                    ],
                    staticClass: "form-control",
                    class: { "bg-input-error": !_vm.order.shippingName },
                    attrs: { type: "text" },
                    domProps: { value: _vm.order.shippingName },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.order, "shippingName", $event.target.value)
                      }
                    }
                  })
                ]
              )
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "出荷予定個数合計：" +
              _vm._s(_vm.calcTotalQuantity(_vm.order.products))
          )
        ]),
        _vm._v(" "),
        _vm.order.valid
          ? _c("span", { staticClass: "status valid" }, [_vm._v("成功")])
          : _c("span", { staticClass: "status error" }, [_vm._v("エラー")]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn mr-l-10 w-50",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.editShipping()
              }
            }
          },
          [
            _c("i", {
              staticClass: "fa",
              class: _vm.order.isEdit ? "fa-floppy-o" : "fa-pencil-square-o",
              attrs: { "aria-hidden": "true" }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn mr-l-10 w-50",
            on: {
              click: function($event) {
                $event.stopPropagation()
                _vm.deleteShipping()
              }
            }
          },
          [
            _c("i", {
              staticClass: "fa fa-trash",
              attrs: { "aria-hidden": "true" }
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.expanded
        ? _c("div", { staticClass: "order-body" }, [
            _c("div", { staticStyle: { display: "flex", gap: "20px" } }, [
              _c("div", { staticClass: "section" }, [
                _c("h4", [_vm._v("基本情報入力")]),
                _vm._v(" "),
                _vm.order.isEdit
                  ? _c("div", [
                      _c("div", { staticClass: "input-edit" }, [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.shipment.name,
                              expression: "order.shipment.name"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "bg-input-error": !_vm.order.shipment.name },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.shipment.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.shipment,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-edit" }, [
                        _vm._m(3),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.shipment.postalCode,
                              expression: "order.shipment.postalCode"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "bg-input-error": !_vm.order.shipment.postalCode
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.shipment.postalCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.shipment,
                                "postalCode",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(4),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.shipment.address1,
                              expression: "order.shipment.address1"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "bg-input-error": !_vm.order.shipment.address1
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.shipment.address1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.shipment,
                                "address1",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-edit" }, [
                        _c("b", [_vm._v("住所2: ")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.shipment.address2,
                              expression: "order.shipment.address2"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.shipment.address2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.shipment,
                                "address2",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-edit" }, [
                        _vm._m(5),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.shipment.phoneNo,
                              expression: "order.shipment.phoneNo"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "bg-input-error": !_vm.order.shipment.phoneNo
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.shipment.phoneNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.shipment,
                                "phoneNo",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  : _c("div", [
                      _c("div", [
                        _c("b", [_vm._v("発送元名: ")]),
                        _vm._v(_vm._s(_vm.order.shipment.name))
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [_vm._v("郵便番号: ")]),
                        _vm._v(
                          _vm._s(_vm.order.shipment.postalCode) +
                            "\n            "
                        ),
                        _c("b", [_vm._v("住所1: ")]),
                        _vm._v(
                          _vm._s(_vm.order.shipment.address1) + "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.order.shipment.address2
                        ? _c("div", [
                            _c("b", [_vm._v("住所2: ")]),
                            _vm._v(
                              _vm._s(_vm.order.shipment.address2) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [_vm._v("電話番号: ")]),
                        _vm._v(_vm._s(_vm.order.shipment.phoneNo))
                      ])
                    ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "section" }, [
                _c("h4", [_vm._v("お届け先情報入力")]),
                _vm._v(" "),
                _vm.order.isEdit
                  ? _c("div", [
                      _c("div", { staticClass: "input-edit" }, [
                        _vm._m(6),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.delivery.name,
                              expression: "order.delivery.name"
                            }
                          ],
                          staticClass: "form-control",
                          class: { "bg-input-error": !_vm.order.delivery.name },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.delivery.name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.delivery,
                                "name",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-edit" }, [
                        _vm._m(7),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.delivery.postalCode,
                              expression: "order.delivery.postalCode"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "bg-input-error": !_vm.order.delivery.postalCode
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.delivery.postalCode },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.delivery,
                                "postalCode",
                                $event.target.value
                              )
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm._m(8),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.delivery.address1,
                              expression: "order.delivery.address1"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "bg-input-error": !_vm.order.delivery.address1
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.delivery.address1 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.delivery,
                                "address1",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-edit" }, [
                        _c("b", [_vm._v("住所2: ")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.delivery.address2,
                              expression: "order.delivery.address2"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.delivery.address2 },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.delivery,
                                "address2",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "input-edit" }, [
                        _vm._m(9),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.order.delivery.phoneNo,
                              expression: "order.delivery.phoneNo"
                            }
                          ],
                          staticClass: "form-control",
                          class: {
                            "bg-input-error": !_vm.order.delivery.phoneNo
                          },
                          attrs: { type: "text" },
                          domProps: { value: _vm.order.delivery.phoneNo },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.order.delivery,
                                "phoneNo",
                                $event.target.value
                              )
                            }
                          }
                        })
                      ])
                    ])
                  : _c("div", [
                      _c("div", [
                        _c("b", [_vm._v("お届け先名: ")]),
                        _vm._v(_vm._s(_vm.order.delivery.name))
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [_vm._v("郵便番号: ")]),
                        _vm._v(
                          _vm._s(_vm.order.delivery.postalCode) +
                            "\n            "
                        ),
                        _c("b", [_vm._v("住所1: ")]),
                        _vm._v(
                          _vm._s(_vm.order.delivery.address1) + "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _vm.order.delivery.address2
                        ? _c("div", [
                            _c("b", [_vm._v("住所2: ")]),
                            _vm._v(
                              _vm._s(_vm.order.delivery.address2) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", [
                        _c("b", [_vm._v("電話番号: ")]),
                        _vm._v(_vm._s(_vm.order.delivery.phoneNo))
                      ])
                    ])
              ])
            ]),
            _vm._v(" "),
            _vm.order.isEdit
              ? _c("div", { staticClass: "text-danger" }, [
                  _vm._v("(*) 必須項目")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "section" }, [
              _c("h4", [_vm._v("商品情報入力")]),
              _vm._v(" "),
              _vm.order.isEdit
                ? _c(
                    "button",
                    {
                      staticClass: "btn btn-primary mr-b-10",
                      attrs: { type: "button" },
                      on: { click: _vm.openModalProductAdd }
                    },
                    [_vm._v("商品選択")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("table", [
                _c("thead", [
                  _c("tr", [
                    _c("th", [_vm._v("出荷する商品")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("ACROSS在庫数")]),
                    _vm._v(" "),
                    _c("th", [_vm._v("出荷予定数")]),
                    _vm._v(" "),
                    _vm.order.isEdit ? _c("th") : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.order.products, function(p, index) {
                    return _c("tr", { key: index }, [
                      _c(
                        "td",
                        {
                          staticClass: "flexbox gap-10",
                          staticStyle: { "flex-wrap": "nowrap" }
                        },
                        [
                          p.image
                            ? _c("div", [
                                _c("img", {
                                  attrs: { src: p.image, width: "75" }
                                })
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _c("div", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(p.itemName) +
                                  "\n                "
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flexbox gap-10" }, [
                              _c("span", [
                                _c("b", [_vm._v("ASIN:")]),
                                _vm._v(_vm._s(p.asin))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _c("b", [_vm._v("SKU:")]),
                                _vm._v(_vm._s(p.sku))
                              ])
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "flexbox gap-10" }, [
                              _c("span", [
                                _c("b", [_vm._v("商品ID:")]),
                                _vm._v(_vm._s(p.itemId))
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _c("b", [_vm._v("商品ラベル:")]),
                                _vm._v(_vm._s(p.goodsLabel))
                              ])
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          "\n              " +
                            _vm._s(p.acrossQuantity) +
                            "個\n            "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm.order.isEdit
                          ? _c("div", { staticClass: "input-edit" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: p.quantity,
                                    expression: "p.quantity"
                                  }
                                ],
                                staticClass: "form-control w-100",
                                class: {
                                  "bg-input-error":
                                    !p.quantity || p.quantity <= 0
                                },
                                attrs: { type: "number", min: "1" },
                                domProps: { value: p.quantity },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(p, "quantity", $event.target.value)
                                  }
                                }
                              }),
                              _vm._v("個\n              ")
                            ])
                          : _c("span", [_vm._v(_vm._s(p.quantity) + "個")])
                      ]),
                      _vm._v(" "),
                      _vm.order.isEdit
                        ? _c("td", [
                            _c("div", { staticClass: "text-center" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-delete-selected-product",
                                  attrs: { type: "button" },
                                  on: {
                                    click: function($event) {
                                      _vm.handleDelete(p)
                                    }
                                  }
                                },
                                [_vm._v("削除")]
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  }),
                  0
                )
              ])
            ]),
            _vm._v(" "),
            _vm.order.errors && _vm.order.errors.length
              ? _c(
                  "div",
                  { staticClass: "error-box" },
                  _vm._l(_vm.order.errors, function(e, i) {
                    return _c("div", { key: i }, [
                      _c("i", {
                        staticClass: "fa fa-exclamation-triangle",
                        attrs: { "aria-hidden": "true" }
                      }),
                      _vm._v(" "),
                      _c("span", { domProps: { innerHTML: _vm._s(e) } })
                    ])
                  }),
                  0
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.openProductAddModal
        ? _c("shipping-multi-channel-product-add", {
            ref: "shippingMultiProductAddModal",
            attrs: {
              iconUrls: _vm.iconUrls,
              selectedProducts: _vm.order.products
            },
            on: {
              close: _vm.closeModalProductAdd,
              handleSelectedProduct: _vm.handleSelectedProduct,
              handleSelectedProducts: _vm.handleSelectedProducts
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("依頼番号 "),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(" : ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _vm._v("出荷名"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(" : ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("発送元名"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("郵便番号"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("住所1"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("電話番号"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("お届け先名"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("郵便番号"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("住所1"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("b", [
      _vm._v("電話番号"),
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(": ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75d4b340", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75d4b340","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/OrderCard.vue
// module id = null
// module chunks = 